import { useState, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import _get from 'lodash/get';
import { AppContext } from 'commons-ui';
import useService from '../../utils/useService';
import { hydrateFormData, dehydrateFormData } from '../../utils/formDataParser';
import { ITDSOfferRawData, ISegmentOffer } from '../../utils/type';
import { ICustomResponse } from '../../../tdsConfigs/utils/type';

const useClone = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { app, showAlert } = useContext(AppContext);
	const history: any = useHistory();
	const location = useLocation();
	const { requestCreateOffer } = useService();

	const CloneOffer = (conversionOffer: ISegmentOffer) => {
		setShowLoader(true);
		requestCreateOffer(app.appName, { ...conversionOffer }).then(
			(res: ICustomResponse) => {
				if (res?.status !== 200 || !res?.data?.success) {
					showAlert(`Error: ${res?.data?.error || 'Error occured while cloning the TDS offer'}`, { type: 'error' });
					setShowLoader(false);
				} else {
					showAlert('Offer Created');
					history.goBack();
				}
			},
			(err: any) => {
				showAlert(`Error: ${err?.response?.data?.error}`, { type: 'error' });
				setShowLoader(false);
			}
		);
	};

	const handleFormSubmit = (submittedData: ITDSOfferRawData) => {
		CloneOffer(dehydrateFormData(submittedData));
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return {
		data: {
			...hydrateFormData(_get(location, ['state', 'rowData'])),
			segmentList: history?.location?.state?.segmentList,
			mapValue: JSON.stringify(history?.location?.state?.mapValues)
		},
		showLoader,
		handleFormSubmit,
		handleFormCancel,
		setShowLoader
	};
};

export default useClone;
